import { createRoute } from "@tanstack/react-router";

import { ProtectedRoute } from "../auth/ProtectedRoute";
import { RoutingMatrix } from "../components/cockpit/settings/RoutingMatrix";
import { Badge } from "../components/ui/badge";
import { useAlertPolicies, useAlertTypes, useCollaborators, useRoutes } from "../queries";
import { rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/routing",
  component: RoutingScreen,
});

function RoutingScreen() {
  return (
    <ProtectedRoute requiredRoles={["owner"]}>
      <RoutingContent />
    </ProtectedRoute>
  );
}

function RoutingContent() {
  const alertTypes = useAlertTypes();
  const policies = useAlertPolicies();
  const routes = useRoutes();
  const collaborators = useCollaborators();

  return (
    <section className="space-y-5">
      <div>
        <Badge variant="slate">Admin</Badge>
        <h1 className="mt-3 text-2xl font-semibold text-slate-950">Who gets alerted</h1>
        <p className="mt-1 text-sm text-slate-600">Choose who receives each alert by route and channel.</p>
      </div>
      <RoutingMatrix
        alertTypes={alertTypes.data?.items || []}
        routes={routes.data?.items || []}
        collaborators={collaborators.data?.items || []}
        policies={policies.data?.items || []}
      />
    </section>
  );
}
